// resources/js/app.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css'; 
import '../css/build/app.css';
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";
// import '../css/source/app.scss';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { fab } from '@fortawesome/free-solid-svg-icons';
// import '@fortawesome/free-brands-svg-icons';
// library.add(fab);


import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons'
import ScrollToTop from "react-scroll-to-top";

library.add(fas, faCheckSquare, faCoffee)

require('./bootstrap');

// React Components
// require('./components/Header')
// require('./components/StartpageContent')
// require('./components/AboutContent')
// require('./components/QualityContent')
// require('./components/ContactContent')
// require('./components/Footer')

import Header from './components/Header';
import Footer from './components/Footer';
import StartpageContent from './components/StartpageContent';
import AboutContent from './components/AboutContent';
import QualityContent from './components/QualityContent';
import ContactContent from './components/ContactContent';

export default function App() {
    // const prefix = "/schum-asia/public";
    return (
        <BrowserRouter>
            <div className="ps-2 pe-2 ">
                <ScrollToTopOnRouteChange>
                    <ScrollToTop smooth />
                    <Header/>
                    
                    <Routes>
                        {/* <Route path={prefix + '/'} element={< StartpageContent />}></Route>
                        <Route path={prefix + '/about'} element={< AboutContent />}></Route>
                        <Route path={prefix + '/quality'} element={< QualityContent />}></Route>
                        <Route path={prefix + '/contact'} element={< ContactContent />}></Route> */}

                        <Route path='/' element={< StartpageContent />}></Route>
                        <Route path='/about' element={< AboutContent />}></Route>
                        <Route path='/quality' element={< QualityContent />}></Route>
                        <Route path='/contact' element={< ContactContent />}></Route>
                    </Routes>
                    <Footer/>
                </ScrollToTopOnRouteChange>
            </div>
        </BrowserRouter>
    );
}
  
//   export default App;

if (document.getElementById('app')) {
    const container = document.getElementById('app');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<App />);
}